var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs-down-arrow.svg",
    clipPath: "url(#clip0_16653_41688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.96481 6.36476C3.99304 6.40575 4.0308 6.43927 4.07486 6.46243C4.11892 6.48559 4.16795 6.49768 4.21772 6.49768C4.26749 6.49768 4.31652 6.48559 4.36058 6.46243C4.40464 6.43927 4.44241 6.40575 4.47063 6.36476L7.23973 2.36495C7.27178 2.31881 7.29058 2.26478 7.29408 2.20871C7.29757 2.15264 7.28564 2.09669 7.25957 2.04693C7.2335 1.99717 7.19429 1.95551 7.14621 1.92646C7.09812 1.89742 7.043 1.88211 6.98682 1.8822H1.44862C1.39258 1.88243 1.33765 1.89794 1.28976 1.92705C1.24187 1.95616 1.20282 1.99778 1.17681 2.04742C1.1508 2.09707 1.13882 2.15287 1.14215 2.20881C1.14548 2.26476 1.164 2.31874 1.19571 2.36495L3.96481 6.36476Z",
    fill: "#DA0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16653_41688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.38426,
    height: 7.38426,
    fill: "white",
    transform: "translate(0.525635 0.343811)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRed);
export default __webpack_public_path__ + "static/media/arrow_red.1365ab93a0993241c71bddd8b8e66d49.svg";
export { ForwardRef as ReactComponent };